import { ESuburbanUtility } from '../../../../api-models/common/json_query';
import { createTermTagManager } from '../../utils/createTermTagManager';

export const drainageSuburbanUtilityTagManager = createTermTagManager({
  jsonQueryKey: 'has_drainage',
  label: 'С канализацией',
  id: ESuburbanUtility.Drainage,
});

export const electricitySuburbanUtilityTagManager = createTermTagManager({
  jsonQueryKey: 'electricity',
  label: 'С электричеством',
  id: ESuburbanUtility.Electricity,
});

export const gasSuburbanUtilityTagManager = createTermTagManager({
  jsonQueryKey: 'gas',
  label: 'С газом',
  id: ESuburbanUtility.Gas,
});

export const waterSuburbanUtilityTagManager = createTermTagManager({
  jsonQueryKey: 'has_water',
  label: 'Есть водоснабжение',
  id: ESuburbanUtility.Water,
});
